import {CSSProperties, FC} from 'react';


export interface IIconCarFrontNissanProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconCarFrontNissan: FC<IIconCarFrontNissanProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M17.6 10.125h-.256l-1-2.34c-.365-.851-1.245-1.409-2.224-1.41h-4.8c-1.146-.003-2.135.754-2.36 1.808l-.416 1.942H6.4c-1.325 0-2.4 1.007-2.4 2.25v2.25c0 .199.084.39.234.53.15.141.354.22.566.22h.8c0 1.243 1.075 2.25 2.4 2.25s2.4-1.007 2.4-2.25h3.2c0 1.243 1.075 2.25 2.4 2.25 1.326 0 2.4-1.007 2.4-2.25h.8c.442 0 .8-.336.8-.75v-2.25c0-1.243-1.075-2.25-2.4-2.25Zm-4.8-2.25h1.32a.8.8 0 0 1 .736.473l.76 1.777H12.8v-2.25Zm-4.272.6c.077-.355.414-.607.8-.6H11.2v2.25H8.176l.352-1.65ZM8 16.125c-.442 0-.8-.336-.8-.75s.358-.75.8-.75c.442 0 .8.336.8.75s-.358.75-.8.75Zm8 0c-.442 0-.8-.336-.8-.75s.358-.75.8-.75c.442 0 .8.336.8.75s-.358.75-.8.75Zm2.4-2.25h-.624A2.475 2.475 0 0 0 16 13.138c-.676 0-1.321.268-1.776.737H9.776A2.475 2.475 0 0 0 8 13.138c-.676 0-1.321.268-1.776.737H5.6v-1.5c0-.414.358-.75.8-.75h11.2c.442 0 .8.336.8.75v1.5Z" clipRule="evenodd" />
        </svg>
    );
};
